import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Marte H.',
    location: 'Oslo',
    rating: 5,
    text: 'Treningsvideoene er enkle å følge, og trenerne vet akkurat hvordan de skal motivere deg. Jeg elsker variasjonen i innholdet – det holder meg engasjert dag etter dag!',
    avatar: '🏃‍♀️',
  },
  {
    name: 'Erik S.',
    location: 'Bergen',
    rating: 5,
    text: 'Jeg kan veksle mellom intense styrkeøkter og rolig yoga alt etter humøret. Oppskriftsdelen har vært en sann åpenbaring – enkle og sunne retter som faktisk smaker godt.',
    avatar: '💪',
  },
  {
    name: 'Sofie L.',
    location: 'Stavanger',
    rating: 5,
    text: 'Som nybegynner var jeg usikker på hvor jeg skulle begynne. Workout ON gjorde hele greia superenkel – videoene er godt forklart og trenerne er tålmodige og oppmuntrende.',
    avatar: '🌟',
  },
  {
    name: 'Jonas K.',
    location: 'Trondheim',
    rating: 5,
    text: 'Den komplette pakken! Fra treningstips til sunne oppskrifter og motiverende musikk – alt jeg trenger for å holde rutinen er samlet på ett sted. Fantastisk!',
    avatar: '🔥',
  },
  {
    name: 'Ingrid M.',
    location: 'Tromsø',
    rating: 5,
    text: 'Trenerne er fantastiske og programmene er krevende, men gjennomførbare. Jeg har aldri vært i bedre form – Workout ON har virkelig forandret treningsvanene mine.',
    avatar: '⚡',
  },
];

const Stars = ({ count }) => (
  <div className="flex space-x-1">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-primary-light text-primary-light" />
    ))}
  </div>
);

const Benefits = () => {
  return (
    <section id="anmeldelser" className="py-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-light text-sm font-semibold uppercase tracking-widest">Anmeldelser</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-black text-white font-heading">
            Hva sier{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
              brukerne?
            </span>
          </h2>
          <p className="mt-4 text-lg text-slate-400 max-w-2xl mx-auto">
            Tusenvis av treningsentusiaster stoler på Workout ON for å nå helse- og treningsmålene sine.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className={`bg-card-dark border border-border-dark rounded-2xl p-7 hover:border-primary/40 transition-all duration-300 ${
                index === 2 ? 'md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <Stars count={t.rating} />
              <p className="mt-4 text-slate-300 leading-relaxed text-sm italic">"{t.text}"</p>
              <div className="mt-6 flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary/10 border border-primary/20 rounded-full flex items-center justify-center text-lg">
                  {t.avatar}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-slate-500 text-xs">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-card-dark border border-border-dark rounded-2xl p-8 text-center">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <Stars count={5} />
            <span className="text-white font-bold text-xl">4.9</span>
          </div>
          <p className="text-slate-400 text-sm">Basert på over 2.400 vurderinger</p>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
